import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';

export const StyledDrawer = styled(Drawer, {
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    '@media (max-width: 464px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    '@media (max-width: 464px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
});
